// extracted by mini-css-extract-plugin
export default {"productCarousel":"K1-z"};